// Action Types
export const CONVERT_TO_WIN_REQUEST = "CONVERT_TO_WIN_REQUEST";
export const CONVERT_TO_WIN_SUCCESS = "CONVERT_TO_WIN_SUCCESS";
export const CONVERT_TO_WIN_FAILURE = "CONVERT_TO_WIN_FAILURE";

// Action Creators
export const fetchConvertToWinRequest = ({ ids,userId}) => {
  return (dispatch) => {
    dispatch({
      type: CONVERT_TO_WIN_REQUEST,
      payload: {ids,userId },
    });
  };
};
export const fetchConvertToWinSuccess = (data) => ({
  type: CONVERT_TO_WIN_SUCCESS,
  payload: data,
});
export const fetchConvertToWinFailure = (error) => ({
  type: CONVERT_TO_WIN_FAILURE,
  payload: error,
});
